// Етикетът на ЧАСТ от продукт на няколко станции („Пилешко филе" на Скара +
// Студена): на монитор с повече от една станция редът се вижда по веднъж за
// всяка и етикетът казва чия е частта (виж stationParts.ts). Стои в реда на
// името — не добавя височина, така че packing-ът на решетката не се мени.
// Свива се с многоточие (до 45% от реда): името на ястието е по-важно от
// етикета и в 340px колона не бива да изчезва заради него.
const StationPartTag = ({ name }: { name: string }) => (
  <span title={name} className="min-w-0 max-w-[45%] truncate rounded-[6px] bg-shade-2 px-[6px] py-[1px] text-[11.5px] font-bold uppercase tracking-[0.4px] text-body">
    {name}
  </span>
);

export default StationPartTag;
